// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tooltip-input .input-container {
  position: relative;
  border-radius: 2px;
  border-color: 2px solid gray;
  margin-bottom: 20px;
}
tooltip-input .input-container:hover > .tooltip-icon {
  opacity: 1;
  transition: 0.2s;
}
tooltip-input .tooltip-icon {
  border-radius: 50%;
  position: absolute;
  top: 0px;
  opacity: 0;
  right: 0px;
  width: 30px;
  height: 30px;
  text-align: center;
  font-weight: 700;
  font-size: 15px;
  line-height: 30px;
  padding: 0px;
  cursor: pointer;
  z-index: 2;
  color: var(--dark);
  background-color: white;
  border: 1px solid rgba(1, 1, 1, 0.15);
}
tooltip-input .tooltip-icon:hover {
  /**
  padding: 0px;
  border: 1px solid gray; */
  border: 1px solid rgba(1, 1, 1, 0.4);
  color: var(--dark);
}
tooltip-input .tooltip-icon:hover + .tooltip,
tooltip-input .tooltip-icon + .tooltip:hover {
  opacity: 1;
  display: block;
  transition: opacity 0.2s;
  transform: translateY(0);
  pointer-events: initial;
  background-color: white;
}
tooltip-input .input-container .tooltip {
  opacity: 0;
  display: none;
  transition: 0.2s;
  position: absolute;
  top: 34px;
  background: rgba(255, 255, 255, 0.7);
  padding: 10px;
  margin: 0;
  pointer-events: none;
  box-shadow: 0 5px 10px rgba(20, 20, 20, 0.1);
  border: 1px solid #bbb;
  font-family: "Open Sans", sans-serif;
  right: 10px;
  line-height: 120%;
  width: 90%;
  min-width: 140px;
  box-sizing: border-box;
  color: black;
  border-radius: var(--border-radius);
  z-index: 4;
}
tooltip-input .input-styler input,
tooltip-input .input-styler textarea,
tooltip-input .input-styler select {
  resize: vertical;
  width: 100%;
  padding: 5px;
  border-radius: var(--border-radius);
  min-height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: transparent;
  font-family: "Open Sans", sans-serif;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.95) !important;
}
tooltip-input .input-styler button {
  padding: 5px;
  margin: 5px 0;
  min-height: 40px;
  width: 100%;
}
tooltip-input .input-styler select {
  border-radius: var(--border-radius);
  height: 40px;
  color: black;
}
tooltip-input .input-styler option {
  color: black;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/tooltip-input/tooltip-input.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AADR;AAII;EACI,UAAA;EACA,gBAAA;AAFR;AAKI;EAII,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qCAAA;AANR;AASI;EACI;;2BAAA;EAGA,oCAAA;EACA,kBAAA;AAPR;AAWI;;EAEI,UAAA;EACA,cAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;AATR;AAYI;EACI,UAAA;EACA,aAAA;EACA,gBAAA;EAEA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;EACA,4CAAA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,mCAAA;EACA,UAAA;AAXR;AAcI;;;EAGI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,sDAAA;AAZR;AAeI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AAbR;AAgBI;EACI,mCAAA;EACA,YAAA;EACA,YAAA;AAdR;AAiBI;EACI,YAAA;AAfR","sourcesContent":["tooltip-input {\n\n    .input-container {\n        position: relative;\n        border-radius: 2px;\n        border-color: 2px solid gray;\n        margin-bottom: 20px;\n    }\n\n    .input-container:hover > .tooltip-icon {\n        opacity: 1;\n        transition: .2s;\n    }\n\n    .tooltip-icon {\n        // border: 1px solid rgba(0.9, 0.9, 0.9, 0.1);\n        // background: white;\n        // color: black;\n        border-radius: 50%;\n        position: absolute;\n        top: 0px;\n        opacity: 0;\n        right: 0px;\n        width: 30px;\n        height: 30px;\n        text-align: center;\n        font-weight: 700;\n        font-size: 15px;\n        line-height: 30px;\n        padding: 0px;\n        cursor: pointer;\n        z-index: 2;\n        color: var(--dark);\n        background-color: white;\n        border: 1px solid rgba(0.9, 0.9, 0.9, 0.15);\n    }\n\n    .tooltip-icon:hover {\n        /**\n        padding: 0px;\n        border: 1px solid gray; */\n        border: 1px solid rgba(0.9, 0.9, 0.9, 0.4);\n        color: var(--dark);\n        \n    }\n\n    .tooltip-icon:hover+.tooltip,\n    .tooltip-icon+.tooltip:hover {\n        opacity: 1;\n        display: block;\n        transition: opacity .2s;\n        transform: translateY(0);\n        pointer-events: initial;\n        background-color: white;\n    }\n\n    .input-container .tooltip {\n        opacity: 0;\n        display: none;\n        transition: .2s;\n        // transform: translateY(-10px);\n        position: absolute;\n        top: 34px;\n        background: rgba(255, 255, 255, .7);\n        padding: 10px;\n        margin: 0;\n        pointer-events: none;\n        box-shadow: 0 5px 10px rgba(20, 20, 20, .1);\n        border: 1px solid #bbb;\n        font-family: 'Open Sans', sans-serif;\n        right: 10px;\n        line-height: 120%;\n        width: 90%;\n        min-width: 140px;\n        box-sizing: border-box;\n        color: black;\n        border-radius: var(--border-radius);\n        z-index: 4;\n    }\n\n    .input-styler input,\n    .input-styler textarea,\n    .input-styler select {\n        resize: vertical;\n        width: 100%;\n        padding: 5px;\n        border-radius: var(--border-radius);\n        min-height: 40px;\n        border: 1px solid rgba(0,0,0,.1);\n        background: transparent;\n        font-family: 'Open Sans', sans-serif;\n        box-sizing: border-box;\n        background-color: rgba(255, 255, 255, 0.95) !important;\n    }\n\n    .input-styler button {\n        padding: 5px;\n        margin: 5px 0;\n        min-height: 40px;\n        width: 100%;\n    }\n\n    .input-styler select {\n        border-radius: var(--border-radius);\n        height: 40px;\n        color: black;\n    }\n\n    .input-styler option {\n        color: black;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
